import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchAccount, fetchTickets } from '../../../features/account/slice'
import { adapterIndividu, adapterOrganization } from '../../../utils'
import auth from '../../../utils/auth'
import { LoginButton } from '../../buttons'
import { Container } from '../../container'
import { Loader } from '../../loader'
import { profileContext } from './context'
const { getTokenFromLocalStorage } = auth()

const initialProfile = { name: 'Default' }

const Section = ({children}) => {
  return <Container className="text-center px-8">{children}</Container>
}

const StatusHandler = ({status, error, onRetry, children}) => {
  return (status === 'loading') ? (
    <Section>
      <Loader />
    </Section>
  ) : (status === 'succeeded') ? (
    children
  ) : (status === 'failed') ? (
    <Section>
      <div className="text-sm mb-4">Error.</div>
      <p className="link" onClick={onRetry}>Retry</p>
    </Section>
  ) : (status === 'succeeded') ? (
    children
  ) : <LoginButton />
}

const ProfileProvider = ({children}) => {
  const [profile, setProfile] = React.useState({})
  const dispatch = useDispatch()
  const status = useSelector(state => state.account.status)
  const error = useSelector(state => state.account.error)
  const account = useSelector(state => state.account.data)

  useEffect(() => {
    // Do fetch account if:
    // 1. There is token
    // 2. But no data of current account

    // Do NOT fetch account if:
    // 1. There is no token

    const token = getTokenFromLocalStorage()
    if(status === 'idle' && token){
      dispatch(fetchAccount())
    }
  }, [status, dispatch])

  useEffect(() => {
    const { getAccountTypeId } = auth()
    if(account){
      const type = getAccountTypeId(account)
      const adapted = type === 2 ? adapterOrganization(account) : adapterIndividu(account)
      setProfile({
        ...initialProfile,
        ...adapted
      })

      // Fetch individu tickets
      if(type === 1){
        dispatch(fetchTickets())
      }
    }
  }, [account, dispatch])

  return (
    <profileContext.Provider value={{ profile }}>
      <StatusHandler
        status={status}
        error={error}
        onRetry={() => dispatch(fetchAccount())}
      >
        {children}
      </StatusHandler>
    </profileContext.Provider>
  )
}

export { ProfileProvider }
